import JSPath from 'jspath';
import _ from 'lodash';

function getNavItemByRoute(route, rootNode) {
  var params = _.keys(route.params).map(k => `{.params.${k} === "${route.params[k]}"}`).join('');
  var allMatchesWithQuery = JSPath.apply(`..{.name === "${route.name}"}${params}`, rootNode.toJS());
  var results = _.filter(allMatchesWithQuery, (node) => {
    return _.every(_.keys(node.query), (staticQueryKey) => {
      return route.query && route.query[staticQueryKey] === node.query[staticQueryKey];
    });
  });
  return (!_.isEmpty(results) && results[results.length - 1]) || {};
}

function getNavItemTitle(data, route) {
  const navItem = getNavItemByRoute(route, data.getIn(['nav']));
  return navItem && navItem.title || '';
}

export default function(data, route, parents) {
  const titleLevel2 = route.config && route.config.title
      ? route.config.title(
          getNavItemTitle(data, route),
          data.getIn(['title', 'params']).toJS() || {},
          route.params || {},
          route.query || {})
      : (getNavItemTitle(data, route) || data.getIn(['title', 'params', 'flatPageTitle']));

  if (titleLevel2) {
    parents.push(titleLevel2);
  }
  return parents.join(': ');
}



// WEBPACK FOOTER //
// ./src/title.js